import React from "react";
import styled from "styled-components";
import { Alert } from "components/bootstrap";
const StyledAlert = styled(Alert)`
  overflow: auto;
`;
const NoopRetentionStrategyConfiguration = () => /* @__PURE__ */ React.createElement(StyledAlert, null, "This retention strategy is not configurable because it does not do anything.");
export default NoopRetentionStrategyConfiguration;
